var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{staticStyle:{"background-color":"transparent"},attrs:{"readonly":"","type":'text',"name":_vm.inputName,"placeholder":"Choose date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }